import * as React from 'react'
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Typography from "@material-ui/core/Typography";
import {useEffect} from "react";

export default function Q1({handleQ, q1Value, dateLabel}) {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mason-question">
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={q1Value}
          onChange={(e) => handleQ(e, 1)}
        >
          <FormControlLabel value="Yes" control={<Radio/>} label="Attend & Dine"/>
          <FormControlLabel value="Attend" control={<Radio/>} label="Attend"/>
          <FormControlLabel value="No" control={<Radio/>} label="Apologies"/>
        </RadioGroup>
      </FormControl>
    </div>
  )
}